import React, { useState } from 'react';
import { Card, Button, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import styled from 'styled-components';
import CandlestickChart from '../../charts/lightweightcharts/CandlestickChart';

import aiResponses from '../../data/onboarding-ai-responses';
import candlestickData from '../../data/onboarding-candlestick-data';

import LearnWithAI from '../../components/ai/LearnWithAI';

import AnswerFeedback from '../../components/practicesession/AnswerFeedback';


const StyledContainer = styled(Container)`
  background-color: #232830;
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const StyledHeading = styled.h2`
  font-size: 22px;
  font-weight: bold;
  color: #FF7C24;
  margin-bottom: 20px;
  text-align: center;
  margin-top: 10px;
`;

const QuestionText = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  margin-bottom: 20px;
`;

const StyledCard = styled(Card)`
  background-color: ${(props) => (props.selected ? (props.isCorrect ? '#2ECC71' : '#FF4C4C') : '#FFFFFF')};
  color: ${(props) => (props.selected ? '#FFFFFF' : '#232830')};
  border-radius: 15px;
  padding: 15px;
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: scale(1.02);
  }
`;

const StandardButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
  border-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  border-radius: 12px;
  padding: 12px;
  width: 80%;
  max-width: 300px;
  margin-top: 20px;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
    border-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
  }
`;

const OnboardingTrueFalseQuestionChart = ({ question, onNext }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isCorrect, setIsCorrect] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showAIChat, setShowAIChat] = useState(false);
  const [messages, setMessages] = useState([]);
  const [userMessage, setUserMessage] = useState('');
  const [userMessageCount, setUserMessageCount] = useState(0);

  const db = getFirestore();
  const auth = getAuth();


  const handleOptionSelect = async (optionText, optionValue) => {
    if (selectedOption === null) {
      setSelectedOption(optionValue);
      const correct = Number(question.correctanswer) === optionValue;
      setIsCorrect(correct);
      setShowFeedback(true);

      try {
        const currentUser = auth.currentUser;
        await addDoc(collection(db, 'userpracticesessionanswers'), {
          date: serverTimestamp(),
          lessonid: question.lessonid,
          questionid: question.questionid,
          submittedanswer: optionValue,
          userid: currentUser ? currentUser.uid : 'anonymous',
          iscorrect: correct,
        });
      } catch (error) {
        console.error('Error logging answer:', error);
      }
    }
  };

  const handleContinue = () => {
    onNext(isCorrect);
    setShowFeedback(false);
    setSelectedOption(null);
    setIsCorrect(false);
    setUserMessage('');
  };

  const handleLearnWithAI = () => {
    const defaultMessage = 'Learn more using AI';
    const defaultInput = isCorrect
      ? `Help me understand more about ${question.questionname}`
      : 'Help me understand why my answer was incorrect';

    setMessages([{ sender: 'ai', text: defaultMessage }]);
    setUserMessage(defaultInput);
    setShowAIChat(true);
  };

 

  return (
    <StyledContainer>
      <StyledHeading>True or False</StyledHeading>
      <QuestionText>{question.questionname}</QuestionText>
      <CandlestickChart data={candlestickData} />

      <Row className="g-3" style={{ marginTop: '20px' }}>
        {[{ text: "✅ True", value: 1 }, { text: "❌ False", value: 2 }].map((option) => (
          <Col xs={12} key={option.value}>
            <StyledCard
              onClick={() => handleOptionSelect(option.text, option.value)}
              selected={selectedOption === option.value}
              isCorrect={selectedOption === option.value ? isCorrect : null}
            >
              {option.text}
            </StyledCard>
          </Col>
        ))}
      </Row>

      {showFeedback && (
        <>
          <p style={{ fontSize: '18px', fontWeight: 'bold', color: isCorrect ? '#2ECC71' : '#FF4C4C' }}>
            {isCorrect ? "✅ Correct! Click Continue." : "❌ Incorrect. Click Continue."}
          </p>
          <StandardButton onClick={() => setShowAIChat(true)}>Learn withAI</StandardButton>
          <StandardButton onClick={handleContinue}>Continue</StandardButton>
        </>
      )}

<LearnWithAI
  show={showAIChat}
  onClose={() => setShowAIChat(false)}
  question={question}
  isCorrect={isCorrect}
/>

    </StyledContainer>
  );
};

export default OnboardingTrueFalseQuestionChart;